import React, { Component } from 'react';
import './App.css';

class MinoToggle extends Component {
  state = {
    toggleState: 'fetching...'
  }
  componentDidMount = () => {
    fetch('https://u9e8sfj7rd.execute-api.eu-west-2.amazonaws.com/MinoToggleProd')
      .then(res => {
        res.json().then((data) => {
          let state = 'OFF'
          if (data.earlyAccess) state = 'ON'
          this.setState({toggleState: state})
        });
      })
      .catch(() => {
        this.setState({toggleState: 'opps, error'})
      })
  }

  toggle = () => {
    fetch('https://u9e8sfj7rd.execute-api.eu-west-2.amazonaws.com/MinoToggleProd', {    method: 'post',})
      .then(res => {
        res.json().then((data) => {
          let state = 'OFF'
          if (data.earlyAccess) state = 'ON'
          this.setState({toggleState: state})
        });
      })
      .catch(() => {
        this.setState({toggleState: 'opps, error'})
      })
  }
  render() {
    return (
      <div className="App">
        <div>
          <h3>Feature flag is</h3>
          <h1> {this.state.toggleState}</h1>
          <button className='toggleBtn' onClick={this.toggle}>Toggle Feature Flag</button>
        </div>
      </div>
    );
  }
}

export default MinoToggle;



// WEBPACK FOOTER //
// ./src/MinoToggle.js